import {
  Bars3Icon,
  BanknotesIcon,
  BuildingOffice2Icon,
  ChevronDownIcon,
  MagnifyingGlassIcon,
  XMarkIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
  EnvelopeOpenIcon,
  PencilSquareIcon,
  PhoneArrowUpRightIcon,
  PhoneIcon,
  PlusIcon,
  QuestionMarkCircleIcon,
  TrashIcon,
  UsersIcon,
  WrenchIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import {
  axiosWithToast,
  ChangedValues,
  ContactTitle,
  CustomerTitle,
  dateToString,
  dispatchWithToast,
  GoogleMapsButton,
  ItemStatus,
  mapErrors,
  NewLineFormatter,
  ProjectTitle,
  ReportTitle,
  safeString,
  searchFieldsByName,
  StringLimit,
} from "../../../components/Utils";
import { CopyToClipboard, TWclassNames } from "../../../components/utils/Div";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
  createCaseItem,
  deleteCaseItem,
  CASE_DETAIL_FIELDS_WITHOUT_ITEMS,
  fetchCase,
  fetchCaseItems,
  fetchCaseTypes,
  updateCaseItem,
} from "../../../api/case";
import { createCaseGuideRun, fetchActiveCaseGuideTemplates, fetchCaseGuideTemplate } from "../../../api/caseGuides";
import { updateCustomerCommunication } from "../../../api/customer";
import { fetchUsers } from "../../../api/user";
import {
  createCaseAsync,
  deleteCaseAsync,
  updateCaseAsync,
} from "../../../slices/case";
import { PMButton } from "../../../components/utils/PMButton";
import { PMDialog } from "../../../components/utils/PMDialog";
import toast from "react-hot-toast";
import {
  CasePriorityStatus,
  CaseStatus,
} from "../../../components/dashboard/cases/utils";
import { PMField } from "../../../components/utils/PMField";
import { PMDatePicker } from "../../../components/utils/PMDatePicker";
import { CustomerSelector } from "../../../components/utils/moduleSelectors/customerSelector";
import { ContactsSelector } from "../../../components/utils/moduleSelectors/contactSelector";
import ModernEmployeeSelector from "../../../components/utils/Selector/ModernEmployeeSelector";
import { priorityOptions } from "../../../components/dashboard/quality/deviations/utils";
import { DocumentViewer } from "../../../components/dashboard/Media/documentViewer";
import { useSelector } from "react-redux";
import ServiceReportEditModal from "../../../components/dashboard/service/reports/service-report-edit-modal";
import CustomerDialog from "../../../components/dashboard/customers/dialog";
import ServiceAgreementModal from "../../../components/dashboard/service/agreements/modal";
import SimplePrompt from "../../../components/utils/simplePrompt";
import { FieldDialog } from "../../../components/dashboard/inputFields/fieldDialog";
import PMDropdown from "../../../components/utils/PMDropdown";
import PMLinkCard from "../../../components/utils/PMLinkCard";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Dialog, Popover, Transition } from "@headlessui/react";
import { ReportSelector } from "../../../components/utils/moduleSelectors/reportSelector";
import { ProjectSelector } from "../../../components/utils/moduleSelectors/projectSelector";
import { EmployeeSelector } from "../../../components/utils/moduleSelectors/employeeSelector";
import { MentionTextEditor, extractMentionedUsers, CaseItemDescription } from "../../../components/utils/MentionTextEditor";
import { CaseTagSelector } from "../../../components/dashboard/cases/CaseTagSelector";
import { DocumentUploadSectionV4 } from "../../../components/dashboard/Media/DocumentUploadSectionV4";
import { TemplateDialogButton } from "../../../components/dashboard/templates/template-dialog-button";
import CaseUpdateComposer from "../../../components/dashboard/cases/CaseUpdateComposer";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { ResourceLoading } from "../../../components/utils/ResourceLoading";
import { TinyDocumentSection } from "../../../components/dashboard/documents/tinyDocumentSection";
import { Button } from "@mui/material";
import { ObjectRenderErrorBoundary } from "../../../components/utils/ObjectRenderErrorBoundary";
import { SaveBar } from "../../../components/utils/SaveBar";
import CaseGuideOnboardingDialog from "../../../components/dashboard/cases/guides/CaseGuideOnboardingDialog";
import CaseGuideSummaryCard from "../../../components/dashboard/cases/guides/CaseGuideSummaryCard";
import CaseCreateOnboardingDialog from "../../../components/dashboard/cases/guides/CaseCreateOnboardingDialog";

export function TagsView({ tags, onDeleteTag = () => {} }) {
  const tagColor = (tag) => {
    switch (tag?.module) {
      case "report":
        return "bg-blue-100 text-blue-800";
      case "contact":
        return "bg-green-100 text-green-800";
      case "customer":
        return "bg-red-100 text-black";
      case "project":
        return "bg-yellow-100 text-yellow-800";
      case "user":
        return "bg-indigo-100 text-indigo-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const TagTitle = (tag) => {
    switch (tag?.module) {
      case "report":
        return <ReportTitle report={tag?.object} />;
      case "contact":
        return <ContactTitle contact={tag?.object} />;
      case "customer":
        return <CustomerTitle customer={tag?.object} useDialog={true} />;
      case "project":
        return <ProjectTitle project={tag?.object} />;
      case "user":
        return tag?.object?.displayTitle || tag?.object?.name || `@${tag?.module_param}`;
      default:
        return tag?.object?.displayTitle || tag?.module_param || tag?.module || "";
    }
  };

  return tags?.map((item, idx) => {
    return (
      <span
        key={item?.module + item?.module_param}
        className={TWclassNames(
          tagColor(item),
          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mr-2"
        )}
      >
        <span className="flex justify-between">
          <span>
            {(() => {
              const content = item?.id
                ? item?.object
                  ? TagTitle(item)
                  : item?.module_param
                : item?.object
                  ? item?.object?.displayTitle
                  : item?.module + " " + item?.module_param;
              return typeof content === "string" || typeof content === "number" || React.isValidElement(content)
                ? content
                : null;
            })()}
          </span>
          {!item?.id && (
            <button
              type="button"
              className="cursor-pointer"
              onClick={onDeleteTag(idx)}
            >
              <XCircleIcon className="h-5 w-5 ml-2" />
            </button>
          )}
        </span>
      </span>
    );
  });
}

export function CaseItemUpdate(props) {
  const { caseItem } = props;
  const { t } = useTranslation();

  const createItem = async (values) => {
    return await createCaseItem(values);
  };
  const [documents, setDocuments] = useState([]);

  const UploaderCallback = (data, formik) => {
    // Add documents to document state remove duplicates
    const newDocuments = [...documents, ...data];
    const uniqueDocuments = newDocuments.filter(
      (v, i, a) => a.findIndex((t) => t.id === v.id) === i
    );
    setDocuments(uniqueDocuments);

    // Add documents to formik
    formik.setFieldValue("documents", [...documents, ...data]);

    setIsLoading(false);

    // Trigger document refresh in parent component
    if (props.onDocumentRefresh) {
      props.onDocumentRefresh();
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const [openModuleDialog, setOpenModuleDialog] = useState();

  const moduleAction = (type) => {
    setOpenModuleDialog(null);
    setTimeout(() => {
      setOpenModuleDialog(type);
    }, 25);
  };

  const handleModuleSelectorOnClose = (state) => {
    if (!state) {
      setOpenModuleDialog(null);
    }
  };

  const [tags, setTags] = useState([]);

  function TagSelector({ formik }) {
    const moduleTags = [
      { name: t("Report"), action: () => moduleAction("report") },
      { name: t("Contact"), action: () => moduleAction("contact") },
      { name: t("Customer"), action: () => moduleAction("customer") },
      { name: t("Project"), action: () => moduleAction("project") },
    ];

    const onModuleDialogSelectorChange = (type, e) => {
      const payload = {
        module: type,
        module_param: e?.target?.value,
        object: e?.target?.data?.object,
      };

      // add as tags
      // module + id
      setTags([...tags, payload]);

      setOpenModuleDialog(null);

      formik.setFieldValue("tags", [...tags, payload]);
    };

    return (
      <>
        <Popover className="relative">
          <Popover.Button className="inline-flex items-center gap-x-1 text-md px-2 leading-6 text-blue-400 hover:text-blue-600">
            <span>{t("Tags")}</span>
            <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
              <div className="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                {moduleTags.map((item) => (
                  <a
                    key={item.name}
                    onClick={item.action}
                    className="block p-2 hover:text-blue-400 cursor-pointer"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>

        <ContactsSelector
          showField={false}
          open={openModuleDialog === "contact"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("contact", data)}
        />

        <CustomerSelector
          showField={false}
          open={openModuleDialog === "customer"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("customer", data)}
        />

        <ReportSelector
          showField={false}
          open={openModuleDialog === "report"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("report", data)}
        />

        <ProjectSelector
          showField={false}
          open={openModuleDialog === "project"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("project", data)}
        />
      </>
    );
  }

  const handleDeleteTag = (idx, formik) => () => {
    const newTags = [...formik.values.tags];
    newTags.splice(idx, 1);
    formik.setFieldValue("tags", newTags);
    setTags(newTags);
  };

  const initialValues = {
    id: null,
    case_id: caseItem.id,
    dueDate: null,
    title: null,
    description: null,
    documents: null,
    tags: [],
    submit: null,
  };

  function NotifyEmployeeSelector(props) {
    const { setFieldValue } = props;

    const [open, setOpen] = useState(false);
    const [employee, setEmployee] = useState(null);

    useEffect(() => {
      if (setFieldValue && employee) {
        setFieldValue("notifyEmployee", employee);
      }
    }, [employee]);

    return (
      <>
        {employee ? (
          <>
            <div className="flex">
              <div className="flex flex-col ">
                <span className="italic text-xs w-[100px]">
                  Varsel sendes til
                </span>{" "}
                <span>
                  <StringLimit text={employee.displayTitle} />
                </span>
              </div>

              <PMButton
                styleType="minimal px-4"
                onClick={() => setEmployee(null)}
              >
                <XCircleIcon className="h-5 w-5 text-red-400" />
              </PMButton>
            </div>
          </>
        ) : (
          <PMButton onClick={() => setOpen(!open)}>
            {t("Notify Employee")}
          </PMButton>
        )}
        <EmployeeSelector
          showField={false}
          open={open}
          onClose={() => setOpen(false)}
          onChange={(data) => setEmployee(data.target.object)}
        />
      </>
    );
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={Yup.object({
        description: Yup.string().required(t("Description is required")),
      })}
      onSubmit={(values, helpers) => {
        try {
          const mentionedUsers = extractMentionedUsers(values.description || "");
          const userTags = mentionedUsers.map((u) => ({
            module: "user",
            module_param: u.id,
          }));
          const allTags = [...(values.tags || []), ...userTags];
          const notifyEmployee = mentionedUsers[0] ? { id: mentionedUsers[0].id } : values.notifyEmployee;
          axiosWithToast(
            createItem({ ...values, tags: allTags, notifyEmployee }),
            props.onChange
          );
          helpers.setStatus({ success: true });
          helpers.setSubmitting(false);
          helpers.setFieldValue("description", "");
          helpers.resetForm(initialValues);
          setTags([]);
        } catch (err) {
          toast.error("Something went wrong...");
          console.error(err);
          helpers.setStatus({ success: false });
          helpers.setErrors({ submit: err.message });
          helpers.setSubmitting(false);
        }
      }}
    >
      {(formik) => {
        return (
          <Form className="relative h-full shadow-smrounded-lg border border-gray-300 ">
            <div className="focus-within:border-blue-400 focus-within:ring-1 focus-within:ring-blue-400">
              <label htmlFor="description" className="sr-only">
                {t("Description")}
              </label>
              {!formik?.isSubmitting && (
                <div className="block mb-4">
                  <MentionTextEditor
                    name="description"
                    formik={formik}
                    placeholder={t("Write an update...")}
                    minHeight={120}
                    maxHeight={200}
                  />
                </div>
              )}
              {/* Tags section with proper spacing */}
              {formik?.values?.tags && (
                <div className="mt-3 mb-4">
                  <div className="px-2">
                    <TagsView
                      tags={formik.values.tags}
                      onDeleteTag={(idx) => handleDeleteTag(idx, formik)}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="block inset-x-px bottom-0 mt-4">
              <div className="flex items-center justify-between space-x-3 border-t border-gray-200 px-2 py-4 sm:px-3">
                <div className="flex">
                  <div className="">
                    <DocumentUploadSectionV4
                      iconOnly={true}
                      module="CASE"
                      module_param={caseItem.id}
                      parentCallback={(data) => UploaderCallback(data, formik)}
                    />
                  </div>
                  <div className="max-h-[20px] ">
                    <DocumentViewer
                      size="small"
                      pathType="url"
                      documents={formik?.values?.documents}
                      onChange={(data) => {
                        formik.setFieldValue("documents", data);
                      }}
                    />
                  </div>
                  <div className="ml-2 py-2 border-l-2 border-gay-50">
                    <TagSelector formik={formik} />
                  </div>

                  <div className="ml-2 py-2 border-l-2 border-gay-50">
                    <div className="ml-2">
                      <NotifyEmployeeSelector {...formik} />
                    </div>
                  </div>

                  <div className="ml-2 py-2 border-l-2 border-gay-50">
                    <div className="ml-2">
                      <TemplateDialogButton
                        fieldName="description"
                        {...formik}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <button
                    onClick={formik.submitForm}
                    type="button"
                    className="disabled:bg-gray-200 inline-flex items-center rounded-md bg-blue-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                    disabled={formik?.isSubmitting}
                  >
                    {t("Create")}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

/**
 * Isolated User Assigned field - resolves display from caseItem or userOptions.
 * Always derives strings for render; never passes objects that could cause React child errors.
 */
function CaseUserAssignedField({ userId, caseUserAssigned, userOptions, onChange, formik }) {
  const { t } = useTranslation();

  const displayLabel = (() => {
    if (!userId) return t("Velg ansatt");
    if (caseUserAssigned?.id == userId) {
      return safeString(caseUserAssigned?.displayTitle ?? caseUserAssigned?.name, t("Velg ansatt"));
    }
    const opt = userOptions?.find((u) => String(u?.value ?? u?.id) === String(userId));
    if (opt) return safeString(opt?.title ?? opt?.name, t("Velg ansatt"));
    return safeString(caseUserAssigned?.displayTitle ?? caseUserAssigned?.name, t("Velg ansatt"));
  })();

  const selectedForSelector = (() => {
    if (!userId) return [];
    const label = displayLabel !== t("Velg ansatt") ? displayLabel : "";
    return [{ id: userId, name: label, displayTitle: label }];
  })();

  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">{t("User Assigned")}</label>
      <Popover className="relative">
        <Popover.Button className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm shadow-sm hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500">
          <span className={userId ? "text-gray-900" : "text-gray-500"}>{displayLabel}</span>
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in duration-75"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Popover.Panel className="absolute left-0 right-0 top-full z-50 mt-1 overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            {({ close }) => (
              <div className="w-72 max-h-80">
                <ModernEmployeeSelector
                  open={true}
                  selectedEmployees={selectedForSelector}
                  onChange={(employees) => {
                    const emp = employees[0];
                    formik.setFieldValue("user_assigned_id", emp?.id ?? null);
                    close();
                  }}
                  onClose={close}
                  multiple={false}
                />
              </div>
            )}
          </Popover.Panel>
        </Transition>
      </Popover>
    </div>
  );
}

function GuideTemplatePickerDialog({ open, templates, purpose, onClose, onSelect }) {
  const { t } = useTranslation();

  return (
    <PMDialog open={open} onClose={onClose} size="lg" title={t("Velg guide")}>
      <div className="space-y-3">
        <p className="text-sm text-gray-600">
          {purpose === "request_info"
            ? t("Velg hvilken guide du vil bruke for etterspurt info.")
            : t("Velg hvilken guide du vil starte for denne saken.")}
        </p>
        <div className="space-y-2">
          {(templates || []).map((template) => (
            <button
              key={template.id}
              type="button"
              onClick={() => onSelect(template)}
              className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-left transition hover:border-emerald-300 hover:bg-emerald-50"
            >
              <p className="text-sm font-medium text-gray-950">{template.title || t("Case guide")}</p>
              {template.description && (
                <p className="mt-1 line-clamp-2 text-xs text-gray-500">{template.description}</p>
              )}
              <p className="mt-2 text-xs text-gray-400">
                {(template.questions || []).length} {t("spørsmål")}
              </p>
            </button>
          ))}
        </div>
      </div>
    </PMDialog>
  );
}

export default function CaseView(props) {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const [itemState, setItemState] = useState({
    isLoading: true,
    error: false,
    errors: [],
    caseItem: {},
  });

  const {
    open,
    onClose,
    selected,
    onEditing,
    customer,
    project,
    report,
    contact,
    onRefresh,
    title,
    itemTags,
  } = props;

  const { isLoading, error, errors, caseTypes, caseItem, users } = itemState;

  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [serviceAgreementDialogOpen, setServiceAgreementDialogOpen] =
    useState(false);

  const [userOptions, setUserOptions] = useState({
    isLoading: true,
    error: false,
    errors: [],
    data: [],
  });

  const [caseTypeOptions, setCaseTypeOptions] = useState({
    isLoading: true,
    error: false,
    errors: [],
    data: [],
  });

  const [caseItemsState, setCaseItemsState] = useState({
    isLoading: false,
    isLoadingMore: false,
    error: false,
    errors: [],
    data: [],
    page: 1,
    perPage: 20,
    totalCount: 0,
    hasMore: true,
  });
  const caseContentScrollRef = useRef(null);
  const composerRef = useRef(null);

  // Add state for expanded items
  const [expandedItems, setExpandedItems] = useState(new Set());

  // Case menu slideover open state (all screen sizes)
  const [caseMenuOpen, setCaseMenuOpen] = useState(false);

  // Edit state for case items (only own items)
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingItemDraft, setEditingItemDraft] = useState({ title: "", description: "" });
  const [editingCommCaseItemId, setEditingCommCaseItemId] = useState(null);
  const [commCaseEditDraft, setCommCaseEditDraft] = useState({ subject: "", body_text: "" });
  const [savingCommCaseEdit, setSavingCommCaseEdit] = useState(false);

  // Auto-save state: blur + 1 sec = save
  const [saveState, setSaveState] = useState({ isSaving: false, isSuccess: false, isError: false, errorMessage: null });
  const saveTimeoutRef = useRef(null);
  const caseFormSidebarRef = useRef(null);
  const caseFormPanelRef = useRef(null);
  const formikRef = useRef(null);
  const [caseGuideState, setCaseGuideState] = useState({
    open: false,
    template: null,
    pendingRun: null,
    autostartedCaseTypeId: null,
    purpose: "onboarding",
  });
  const [guidePickerState, setGuidePickerState] = useState({
    open: false,
    templates: [],
    purpose: "onboarding",
  });
  const [createCaseDialogOpen, setCreateCaseDialogOpen] = useState(false);
  const [showCaseTypeDialog, setShowCaseTypeDialog] = useState(false);
  const [showPriorityDialog, setShowPriorityDialog] = useState(false);
  const [caseTypeSearch, setCaseTypeSearch] = useState("");

  const currentUser = useSelector((state) => state?.session?.currentUser || state?.auth?.user || state?.user?.user || null);

  const filteredCaseTypeOptions = useMemo(() => {
    const q = caseTypeSearch.trim().toLowerCase();
    const list = Array.isArray(caseTypeOptions.data) ? caseTypeOptions.data : [];
    if (!q) return list;
    return list.filter((opt) =>
      String(opt.title || "")
        .toLowerCase()
        .includes(q)
    );
  }, [caseTypeSearch, caseTypeOptions.data]);

  /** Attaches focusout/focusin listeners for auto-save. Must be a component so useEffect is valid. */
  function CaseFormFocusListeners({ sidebarRef, panelRef, formikRef: fRef, caseId }) {
    useEffect(() => {
      if (!caseId) return;
      const sidebar = sidebarRef?.current;
      const panel = panelRef?.current;
      const handleFocusOut = (e) => {
        const inForm = sidebar?.contains(e.relatedTarget) || panel?.contains(e.relatedTarget);
        if (!inForm && fRef?.current?.dirty) {
          saveTimeoutRef.current = setTimeout(() => fRef?.current?.submitForm(), 1000);
        }
      };
      const handleFocusIn = () => {
        if (saveTimeoutRef.current) {
          clearTimeout(saveTimeoutRef.current);
          saveTimeoutRef.current = null;
        }
      };
      sidebar?.addEventListener("focusout", handleFocusOut);
      sidebar?.addEventListener("focusin", handleFocusIn);
      panel?.addEventListener("focusout", handleFocusOut);
      panel?.addEventListener("focusin", handleFocusIn);
      return () => {
        sidebar?.removeEventListener("focusout", handleFocusOut);
        sidebar?.removeEventListener("focusin", handleFocusIn);
        panel?.removeEventListener("focusout", handleFocusOut);
        panel?.removeEventListener("focusin", handleFocusIn);
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refs are stable, saveTimeoutRef is module-like
    }, [caseId]);
    return null;
  }

  useEffect(() => () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
  }, []);

  // Function to toggle item expansion
  const toggleItemExpansion = (itemId) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  // Function to check if item should be expandable
  const isItemExpandable = (item) => {
    // Don't expand UPDATE case items
    if (item.action === "UPDATE" && item.module === "case") {
      return false;
    }

    // Don't expand ADDED action items - they should always show full content
    if (item.action === "ADDED") {
      return false;
    }

    // Don't expand customer_communication items - they should always show full content
    if (item.module === "customer_communication") {
      return false;
    }

    if (item.module === "case_guide_run") {
      return false;
    }

    // Only expand items that have both description and module content
    const hasDescription = item.description && item.description.trim() !== "";
    const hasModuleContent = displayModuleContent(item) !== undefined;

    return hasDescription || hasModuleContent;
  };

  // Function to check if item is expanded
  const isItemExpanded = (itemId) => {
    return expandedItems.has(itemId);
  };

  // User can only edit/delete their own items
  const canModifyItem = (item) =>
    item?.user?.id != null && currentUser?.id != null && Number(item.user.id) === Number(currentUser.id);

  const canEditOwnCustomerHandlerCommunication = (comm) => {
    if (!comm || currentUser?.id == null) return false;
    const meta = comm.metadata || {};
    return (
      meta.source === "customer_handler" &&
      Number(meta.handler_id) === Number(currentUser.id)
    );
  };

  const rightSideActions = [
    {
      label: "Service Report",
      description: "Create a service report",
      path: "",
      action: () => promptBeforeModuleDialog("report"),
      icon: Cog6ToothIcon,
      iconForeground: "text-teal-700",
      iconBackground: "bg-teal-50",
      completed: caseItem?.report?.id ? true : false,
      show: props.module === "service_report" ? false : true,
      active: true,
    },
    {
      label: "Service Agreement",
      description: "Create a service agreement",
      path: "",
      action: () => promptBeforeModuleDialog("service_agreement"),

      icon: UsersIcon,
      iconForeground: "text-purple-700",
      iconBackground: "bg-purple-50",
      completed: caseItem?.service_agreement?.id ? true : false,
      show: props.module === "service_agreement" ? false : true,
      active: true,
    },
    {
      label: "Project",
      description: "Create a project",
      path: "",
      action: () => promptBeforeModuleDialog("project"),

      icon: BuildingOffice2Icon,
      iconForeground: "text-sky-700",
      iconBackground: "bg-sky-50",
      completed: caseItem?.project?.id ? true : false,
      show: props.module === "project" ? false : true,
      active: true,
    },
    {
      label: "Order",
      description: "Create a order",
      path: "",
      action: () => promptBeforeModuleDialog("order"),
      icon: BanknotesIcon,
      iconForeground: "text-yellow-700",
      iconBackground: "bg-yellow-50",
      completed: caseItem?.order?.id ? true : false,
      show: props.module === "order" ? false : true,
      active: true,
    },
  ];

  async function fetchAndMapTypeOptions() {
    setCaseTypeOptions((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    // Fetch Case types from API?
    return fetchCaseTypes()
      .then((res) => {
        if (res.data) {
          var array = [];
          if (!res.data) return array;
          res?.data?.map((row, i) => {
            const rowParams = {
              value: row.id,
              title: row.title,
              order: i,
            };
            array.push(rowParams);
          });
          setCaseTypeOptions((prevState) => ({
            ...prevState,
            isLoading: false,
            data: array,
          }));
        }
      })
      .catch((err) => {
        let errors = null;
        setCaseTypeOptions((prevState) => ({
          ...prevState,
          isLoading: false,
          error: true,
          errors: errors,
        }));
      });

    // Map into an array with ID and title?

    // Return the array
  }

  async function fetchAndMapUsers() {
    setUserOptions((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    // Fetch Case types from API?
    const controller = {
      filters: [{ name: "role", value: "case" }],
      page: 1,
      query: "",
      sort: "desc",
      sortBy: "id",
      view: "all",
      fields: "id,name,displayTitle",
    };

    await fetchUsers(controller)
      .then((res) => {
        if (res.data) {
          var array = [];
          if (!res.data) return array;
          res?.data?.map((row, i) => {
            const rowParams = {
              value: row.id,
              title: row.name,
              order: i,
            };
            array.push(rowParams);
          });
          setUserOptions((prevState) => ({
            ...prevState,
            isLoading: false,
            data: array,
          }));
        }
      })
      .catch((err) => {
        let errors = null;
        setUserOptions((prevState) => ({
          ...prevState,
          isLoading: false,
          error: true,
          errors: errors,
        }));
      });

    // Map into an array with ID and title?

    // Return the array
  }

  const emptyObjToNull = (obj) =>
    obj && typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj).length === 0 ? null : obj;

  const normalizeCaseItem = (item) => {
    if (!item) return item;
    return {
      ...item,
      project: emptyObjToNull(item.project),
      report: emptyObjToNull(item.report),
      service_agreement: emptyObjToNull(item.service_agreement),
      order: emptyObjToNull(item.order),
      contact: emptyObjToNull(item.contact),
      customer: emptyObjToNull(item.customer),
    };
  };

  const sortCaseItemsAsc = (items = []) => {
    return [...items].sort((a, b) => {
      const aDate = new Date(a?.created_at || 0).getTime();
      const bDate = new Date(b?.created_at || 0).getTime();
      if (aDate === bDate) return Number(a?.id || 0) - Number(b?.id || 0);
      return aDate - bDate;
    });
  };

  const scrollItemsToComposer = () => {
    requestAnimationFrame(() => {
      const el = caseContentScrollRef.current;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
      // Run one more time after layout settles (composer/timeline render race)
      setTimeout(() => {
        const settledEl = caseContentScrollRef.current;
        if (!settledEl) return;
        settledEl.scrollTop = settledEl.scrollHeight;
      }, 80);
    });
  };

  const fetchItemsPage = async (caseId, page, preserveScroll = false) => {
    if (!caseId) return;
    const scrollEl = caseContentScrollRef.current;
    const prevScrollTop = scrollEl?.scrollTop || 0;
    const prevScrollHeight = scrollEl?.scrollHeight || 0;

    if (page === 1) {
      setCaseItemsState((prev) => ({
        ...prev,
        isLoading: true,
        error: false,
        errors: [],
      }));
    } else {
      setCaseItemsState((prev) => ({
        ...prev,
        isLoadingMore: true,
        error: false,
        errors: [],
      }));
    }

    try {
      const result = await fetchCaseItems(caseId, {
        page,
        per_page: caseItemsState.perPage,
        sortBy: "created_at",
        sort: "desc",
      });

      const incomingRaw = Array.isArray(result?.data) ? result.data : [];
      const incoming = sortCaseItemsAsc(incomingRaw);
      const totalCount = Number(result?.totalCount || 0);
      const currentCount = Number(result?.currentCount || incomingRaw.length);
      const hasMore = totalCount > page * caseItemsState.perPage && currentCount > 0;

      setCaseItemsState((prev) => ({
        ...prev,
        isLoading: false,
        isLoadingMore: false,
        data: page === 1 ? incoming : [...incoming, ...prev.data],
        page,
        totalCount,
        hasMore,
      }));

      requestAnimationFrame(() => {
        const el = caseContentScrollRef.current;
        if (!el) return;

        if (page === 1) {
          // Show newest first by anchoring to composer at the bottom.
          scrollItemsToComposer();
          return;
        }

        if (preserveScroll) {
          const nextScrollHeight = el.scrollHeight;
          el.scrollTop = nextScrollHeight - prevScrollHeight + prevScrollTop;
        }
      });
    } catch (err) {
      setCaseItemsState((prev) => ({
        ...prev,
        isLoading: false,
        isLoadingMore: false,
        error: true,
        errors: [t("Could not load case items")],
      }));
    }
  };

  const loadOlderCaseItems = async () => {
    if (!caseItem?.id) return;
    if (caseItemsState.isLoadingMore || caseItemsState.isLoading || !caseItemsState.hasMore) return;
    await fetchItemsPage(caseItem.id, caseItemsState.page + 1, true);
  };

  const handleCaseItemsScroll = (e) => {
    if (!caseItemsState.hasMore || caseItemsState.isLoadingMore || caseItemsState.isLoading) return;
    if (e.currentTarget.scrollTop <= 120) {
      loadOlderCaseItems();
    }
  };

  const getCase = async () => {
    await fetchCase(id, { fields: CASE_DETAIL_FIELDS_WITHOUT_ITEMS })
      .then((res) => {
        setTimeout(() => {
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            caseItem: normalizeCaseItem(res),
          }));
        }, 100);
      })
      .catch((err) => {
        let errors = null;
        if (err?.data?.errors) {
          errors = mapErrors(err?.data?.errors);
        } else {
          errors = ["Something went wrong"];
        }
        setItemState((prevState) => ({
          ...prevState,
          // isLoading: false,
          caseItem: {},
          error: true,
          errors: errors,
        }));
      });
  };

  const createOrUpdateDispatch = (data) => {
    // onEditing(false);
    if (caseItem?.id) {
      const res = dispatch(updateCaseAsync(data));
      return res;
    } else {
      const res = dispatch(createCaseAsync(data));
      return res;
    }
  };

  const openCaseGuide = async (caseTypeId, purpose = "onboarding") => {
    if (!caseTypeId) {
      toast.error(t("Select case type first"));
      return;
    }

    const templates = await fetchActiveCaseGuideTemplates(caseTypeId, purpose === "request_info" ? "onboarding" : purpose);
    if (!templates?.length) {
      toast.error(t("No guide configured for this case type"));
      return;
    }

    if (templates.length > 1) {
      setGuidePickerState({ open: true, templates, purpose });
      return;
    }

    openGuideTemplate(templates[0], purpose);
  };

  const openGuideTemplate = (template, purpose = "onboarding") => {
    setCaseGuideState((prev) => ({
      ...prev,
      open: true,
      template,
      purpose,
    }));
  };

  const chainNextGuideIfNeeded = useCallback(async (caseId, guideResponse, purpose) => {
    const runPayload = guideResponse?.data;
    const nextId = runPayload?.effects_applied?.next_case_guide_template_id;
    if (!caseId || !nextId) return false;
    const full = await fetchCaseGuideTemplate(nextId);
    if (!full?.id) return false;
    setCaseGuideState((prev) => ({
      ...prev,
      open: true,
      template: full,
      purpose: purpose || prev.purpose || "onboarding",
      pendingRun: null,
    }));
    toast.success(t("guide.case_chain_started"));
    return true;
  }, [t]);

  const applyGuideEffectsToFormik = (effects) => {
    const formik = formikRef.current;
    if (!formik || !effects) return;

    if (effects.tag_ids?.length) {
      const currentIds = formik.values.tag_ids || [];
      formik.setFieldValue("tag_ids", [...new Set([...currentIds, ...effects.tag_ids])]);
    }
    if (effects.priority) formik.setFieldValue("priority", effects.priority.toString());
    if (effects.title_suffix && formik.values.title) {
      formik.setFieldValue("title", `${formik.values.title} ${effects.title_suffix}`.trim());
    }
  };

  const handleGuideComplete = async (guideRun) => {
    if (!caseItem?.id) {
      applyGuideEffectsToFormik(guideRun.effects);
      setCaseGuideState((prev) => ({
        ...prev,
        open: false,
        pendingRun: guideRun,
      }));
      return;
    }

    const response = await createCaseGuideRun(
      caseItem.id,
      {
        case_guide_template_id: guideRun.case_guide_template_id,
        purpose: guideRun.purpose,
        answers: guideRun.answers,
        requested_from_customer: guideRun.purpose === "request_info",
      },
      { fields: CASE_DETAIL_FIELDS_WITHOUT_ITEMS }
    );

    if (response?.errors) {
      toast.error(Array.isArray(response.errors) ? response.errors.join(", ") : String(response.errors));
      return;
    }

    if (response?.case) {
      setItemState((prevState) => ({
        ...prevState,
        caseItem: normalizeCaseItem(response.case) ?? response.case,
      }));
    }
    await fetchItemsPage(caseItem.id, 1, false);

    const chained = await chainNextGuideIfNeeded(caseItem.id, response, guideRun.purpose);
    if (!chained) {
      setCaseGuideState((prev) => ({ ...prev, open: false, pendingRun: null }));
    }
  };

  function PostCreateGuidePrompt() {
    useEffect(() => {
      let cancelled = false;
      async function maybeOpenGuide() {
        const shouldOpenGuide = searchParams.get("openGuide") === "1";
        const caseTypeId = caseItem?.case_type?.id || caseItem?.case_type_id;
        const autostartKey = caseItem?.id ? `case_${caseItem.id}` : null;
        if (!shouldOpenGuide || !caseItem?.id || !caseTypeId || caseGuideState.autostartedCaseTypeId === autostartKey) return;

        const templates = await fetchActiveCaseGuideTemplates(caseTypeId, "onboarding");
        const nextParams = new URLSearchParams(searchParams);
        nextParams.delete("openGuide");
        if (!cancelled) setSearchParams(nextParams, { replace: true });
        if (cancelled || !templates?.length) return;

        if (templates.length > 1) {
          setGuidePickerState({ open: true, templates, purpose: "onboarding" });
          setCaseGuideState((prev) => ({
            ...prev,
            autostartedCaseTypeId: autostartKey,
          }));
          return;
        }

        setCaseGuideState((prev) => ({
          ...prev,
          open: true,
          template: templates[0],
          purpose: "onboarding",
          autostartedCaseTypeId: autostartKey,
        }));
      }
      maybeOpenGuide();
      return () => {
        cancelled = true;
      };
    }, [caseItem?.id, caseItem?.case_type?.id, caseItem?.case_type_id, searchParams]);

    return null;
  }

  useEffect(() => {
    setCurrentTab(0);
    fetchAndMapTypeOptions();
    fetchAndMapUsers();
  }, [open]);

  useEffect(() => {
    setItemState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    if (id) {
      getCase();
    } else {
      setItemState((prevState) => ({
        ...prevState,
        isLoading: false,
        caseItem: {},
        error: false,
        errors: null,
      }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (!caseItem?.id) {
      setCaseItemsState((prev) => ({
        ...prev,
        data: [],
        page: 1,
        totalCount: 0,
        hasMore: true,
        isLoading: false,
        isLoadingMore: false,
      }));
      return;
    }

    fetchItemsPage(caseItem.id, 1, false);
  }, [caseItem?.id]);

  // Prevent main page scroll - only items should scroll. Stick case container to viewport.
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    if (!isLoading && caseItem?.id) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = prevOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, [isLoading, caseItem?.id]);

  const MODULE = (module) => {
    switch (module) {
      case "contactForm":
        return "henvndelse via kontaktskjema";
      case "customer":
        return "kunde";
      case "case":
        return "denne saken";
      case "report":
        return "rapport";
      case "description":
        return "beskrivelse";
      case "note":
        return t("Note");
      case "customer_communication":
        return t("Communication");
      case "employee":
        return t("Ansatt");
      default:
        return module;
    }
  };

  const ACTION = (action) => {
    switch (action) {
      case "ADDED":
        return "lagt til";
      case "CREATE":
        return "opprettet";
      case "UPDATE":
        return "oppdatert";
      case "ATTACHED":
        return "lagt til";
      case "LINKED":
        return "lenket til";
      case "CHANGED":
        return "endret";
      case "STATUS_UPDATE":
        return "oppdatert status på";
      case "EMAIL_SENT_TO_EMPLOYEE":
        return "sendt e-post til ansatt i";
      case "sent_sms_to_customer":
        return "sendt SMS til kunde via";
      case "cancel_report_agreement":
        return "kansellert avtale for";
      case "new_report_agreement":
        return "opprettet ny avtale for";
      default:
        return action;
    }
  };

  const itemActivityLabel = (item) => {
    if (item?.module === "case_guide_run") {
      return item?.module_object?.purpose === "request_info"
        ? t("besvarte etterspurt info")
        : t("fullførte guide");
    }

    return `${ACTION(item?.action)} ${MODULE(item?.module)}`.trim();
  };

  const ModuleCard = ({
    item,
    displayObjectName,
    color,
    icon,
    name = item.module,
  }) => {
    const COLOR = (color) => {
      switch (color) {
        case "blue":
          return "bg-blue-50 border border-blue-200";
        case "green":
          return "bg-green-50 border border-green-200";
        case "yellow":
          return "bg-yellow-50 border border-yellow-200";
        case "red":
          return "bg-red-50 border border-red-200";
        default:
          return "bg-blue-50 border border-blue-200";
      }
    };

    const BUTTON = (item) => {
      switch (item.module) {
        case "report":
          return (
            <Link to={"/dashboard/service/reports/" + item?.report?.id}>
              {"Report " + item?.report?.report_number}
            </Link>
          );
      }
    };

    return (
      <div className={COLOR(color) + " rounded-md p-4"}>
        <div className="flex">
          <div className="flex-shrink-0">
            {React.createElement(icon, {
              className: `h-5 w-5 text-${color}-400`,
            })}
          </div>
          <div className="ml-3">
            <h3 className={`text-sm font-medium text-${color}-800`}>
              {t("Attached " + name)}
            </h3>
            <div className={`mt-2 text-sm text-${color}-700`}>
              <p>{item?.module_object?.[displayObjectName]}</p>
            </div>
          </div>
        </div>
        <div className="ml-3">
          <Button>{BUTTON(item)}</Button>
        </div>
      </div>
    );
  };

  const displayModuleContent = (item) => {
    const { module } = item;
    switch (module) {
      case "case":
        // Only return content if there's a meaningful case to link to
        if (item?.id && item?.displayTitle) {
          return (
            <Link
              to={"/dashboard/cases/" + item?.id}
              className="hover:text-blue-800 text-blue-500"
            >
              {item?.displayTitle}
            </Link>
          );
        }
        return undefined;
      case "case_guide_run":
        if (item?.module_object?.id) {
          return <CaseGuideSummaryCard run={item.module_object} />;
        }
        return undefined;
      case "customer":
        // Only return content if there's a meaningful customer to link to
        if (item?.customer?.id && item?.customer?.displayTitle) {
          return (
            <Link
              to={"/dashboard/customers/" + item?.customer?.id}
              className="hover:text-blue-800 text-blue-500"
            >
              {item?.customer?.displayTitle}
            </Link>
          );
        }
        return undefined;
      case "project":
        // Only return content if there's a meaningful project to link to
        if (item?.project?.id && item?.project?.displayTitle) {
          return (
            <Link
              to={"/dashboard/projects/" + item?.project?.id}
              className="hover:text-blue-800 text-blue-500"
            >
              {item?.project?.displayTitle}
            </Link>
          );
        }
        return undefined;
      case "service_agreement":
        // Only return content if there's a meaningful service agreement to link to
        if (
          item?.service_agreement?.id &&
          item?.service_agreement?.agreement_number
        ) {
          return (
            <Link
              to={
                "/dashboard/service/agreements/" + item?.service_agreement?.id
              }
              className="hover:text-blue-800 text-blue-500"
            >
              {"Service Agreement " + item?.service_agreement?.agreement_number}
            </Link>
          );
        }
        return undefined;
      case "order":
        // Only return content if there's a meaningful order to link to
        if (item?.order?.id && item?.order?.order_number) {
          return (
            <Link
              to={"/dashboard/orders/" + item?.order?.id}
              className="hover:text-blue-800 text-blue-500"
            >
              {"Order " + item?.order?.order_number}
            </Link>
          );
        }
        return undefined;
      case "report":
        // Only return content if there's a meaningful report
        if (item?.report?.id) {
          return (
            <ModuleCard
              item={item}
              color="blue"
              icon={WrenchIcon}
              displayObjectName="report"
            />
          );
        }
        return undefined;
      case "note":
        // Only return content if there's a meaningful note
        if (item?.module_object?.note) {
          return (
            <ModuleCard
              item={item}
              color="blue"
              icon={DocumentTextIcon}
              displayObjectName="note"
            />
          );
        }
        return undefined;
      case "phone":
        // Only return content if there's meaningful phone call data
        if (
          item?.module_object?.from_number ||
          item?.module_object?.to_number ||
          item?.module_object?.duration
        ) {
          return (
            <>
              <div
                className={
                  "bg-yellow-50 border border-yellow-200 rounded-md p-4"
                }
              >
                <div className="flex">
                  <div className="flex-shrink-0">
                    <PhoneArrowUpRightIcon className="h-5 w-5 text-yellow-400" />
                  </div>
                  <div className={`mt-2 text-sm text-yellow-700`}>
                    <h3 className={`text-sm font-medium text-yellow-800`}>
                      {t("Phone Call")}
                    </h3>
                    <div className={`mt-2 text-sm text-yellow-700`}>
                      <p>
                        {t("number.from")} {item?.module_object?.from_number}
                      </p>
                      <p>
                        {t("number.to")} {item?.module_object?.to_number}
                      </p>
                      <p>
                        {t("duration")}{" "}
                        {item?.module_object?.duration
                          ? Math.floor(item.module_object.duration / 60) +
                            ":" +
                            String(item.module_object.duration % 60).padStart(
                              2,
                              "0"
                            )
                          : "0:00"}
                      </p>
                      <p>
                        {t("status")} <ItemStatus item={item?.module_object} />
                      </p>
                      <p>
                        {t("started_at")} {item?.module_object?.started_at}
                      </p>
                      <p>
                        {t("ended_at")}{" "}
                        {item?.module_object?.started_at &&
                        item?.module_object?.duration
                          ? new Date(
                              new Date(
                                item.module_object.started_at
                              ).getTime() +
                                item.module_object.duration * 1000
                            ).toLocaleString()
                          : item?.module_object?.ended_at || "N/A"}
                      </p>
                      <p>
                        {t("reason")} {item?.module_object?.reason}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col">
                <span className="mt-4 font-bold">Beskrivelse:</span>
                <div className="mt-4">
                  <CaseItemDescription value={item?.description} />
                </div>
              </div>
            </>
          );
        }
        return undefined;
      case "customer_communication":
        // Only return content if there's meaningful customer communication data
        if (item?.module_object?.id) {
          const comm = item.module_object;
          return (
            <div className="bg-white border-2 border-blue-300 rounded-lg shadow-md p-5 my-3">
              {/* Header with icon and title */}
              <div className="flex items-start justify-between mb-4 pb-3 border-b border-gray-200">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 p-2 bg-blue-100 rounded-lg">
                    {comm.channel === "phone" && <PhoneIcon className="h-6 w-6 text-blue-600" />}
                    {comm.channel === "email" && <EnvelopeOpenIcon className="h-6 w-6 text-blue-600" />}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {t("Communication")}
                    </h3>
                    {comm.subject && (
                      <p className="text-sm text-gray-600 mt-1">{comm.subject}</p>
                    )}
                  </div>
                </div>
                {comm.processed !== undefined && (
                  <div className="flex-shrink-0">
                    {comm.processed ? (
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {t("processed")}
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                        {t("unprocessed")}
                      </span>
                    )}
                  </div>
                )}
              </div>
              
              {/* Content */}
              <div className="space-y-3">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="font-medium text-gray-700">{t("Channel")}:</span>
                    <span className="ml-2 text-gray-900 capitalize">{comm.channel}</span>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">{t("Direction")}:</span>
                    <span className="ml-2 text-gray-900">
                      {comm.direction === "inbound" ? t("inbound") : t("outbound")}
                    </span>
                  </div>
                  {comm.sent_at && (
                    <div className="col-span-2">
                      <span className="font-medium text-gray-700">{t("sent.at")}:</span>
                      <span className="ml-2 text-gray-900">
                        {new Date(comm.sent_at).toLocaleString()}
                      </span>
                    </div>
                  )}
                </div>
                
                {comm.body_text && (
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <p className="font-medium text-gray-700 mb-2">{t("Message")}:</p>
                    <div className="bg-gray-50 rounded-md p-3 border border-gray-200">
                      <p className="text-sm text-gray-900 whitespace-pre-wrap">{comm.body_text}</p>
                    </div>
                  </div>
                )}
                
                {comm.customer && (
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <span className="font-medium text-gray-700">{t("Customer")}:</span>{" "}
                    <Link
                      to={`/dashboard/customers/${comm.customer.id}`}
                      className="text-blue-600 hover:text-blue-800 underline font-medium"
                    >
                      {comm.customer.displayTitle}
                    </Link>
                  </div>
                )}
              </div>
            </div>
          );
        }
        return undefined;
      default:
        return undefined;
    }
  };

  const tabs = [
    { name: "Detaljer", href: "#", current: true },
    { name: "Felter", href: "#", current: false },
    { name: "Dokumenter", href: "#", current: false },
  ];

  const [currentTab, setCurrentTab] = useState(0);

  const [customerDialogOpen, setCustomerDialogOpen] = useState(false);

  function caseTabs() {
    return (
      <div>
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select
            id="tabs"
            name="tabs"
            className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            defaultValue={tabs[currentTab].name}
          >
            {tabs.map((tab, index) => (
              <option key={tab.name} value={tab.index}>
                {tab.name}
              </option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex" aria-label="Tabs">
              {tabs.map((tab, index) => (
                <a
                  key={tab.name}
                  onClick={() => setCurrentTab(index)}
                  className={TWclassNames(
                    index === currentTab
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                    "w-1/4 border-b-2 py-4 px-1 text-center text-sm font-medium"
                  )}
                  aria-current={tab.current ? "page" : undefined}
                >
                  {tab.name}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    );
  }

  const [fieldDialogOpen, setFieldDialogOpen] = useState(false);

  function caseFields() {
    return (
      <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
        <PMButton onClick={() => setFieldDialogOpen(true)}>
          Legg til felt
        </PMButton>
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
              >
                Name
              </th>
              <th
                scope="col"
                className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
              >
                Value
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {caseItem?.fields?.map((field) => (
              <tr key={field.name}>
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                  {field.name}
                </td>
                <td className="py-4 px-3 text-sm text-gray-500 min-w-[200px]">
                  <CopyToClipboard>
                    {typeof field.value === "string" || typeof field.value === "number"
                      ? String(field.value)
                      : ""}
                  </CopyToClipboard>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  const handleDescriptionItemChange = (e, formik) => {
    const { name, value } = e.target;
    const items = [...formik.values.items];
    items[0].description = value;
    if (itemTags) {
      items[0].tags = itemTags;
    }
    formik.setFieldValue("items", items);
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const [removeCaseItemPromptOpen, setRemoveCaseItemPromptOpen] =
    useState(false);

  const handleDeleteItem = (id) => {
    setSelectedItem(id);
    setRemoveCaseItemPromptOpen(true);
  };

  const removeCaseItem = () => {
    deleteCaseItem({ case_id: caseItem?.id, id: selectedItem })
      .then((res) => {
        setCaseItemsState((prev) => ({
          ...prev,
          data: prev.data.filter((item) => item.id !== selectedItem),
          totalCount: Math.max(0, prev.totalCount - 1),
        }));

        setRemoveCaseItemPromptOpen(false);
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("Could not delete item"));
      });
  };

  const handleSaveCustomerCommunicationCaseItem = async (item) => {
    const comm = item?.module_object;
    const customerId = comm?.customer?.id;
    if (!customerId || !comm?.id) return;
    setSavingCommCaseEdit(true);
    try {
      const res = await updateCustomerCommunication(customerId, comm.id, {
        subject: commCaseEditDraft.subject || "",
        body_text: commCaseEditDraft.body_text || "",
      });
      if (res?.errors?.length) {
        toast.error(res.errors[0]);
        return;
      }
      if (res?.id) {
        toast.success(t("customer.handler.communication.update.success"));
        setCaseItemsState((prev) => ({
          ...prev,
          data: prev.data.map((i) =>
            i.id === item.id
              ? {
                  ...i,
                  module_object: {
                    ...i.module_object,
                    ...res,
                    customer: i.module_object?.customer || comm?.customer,
                  },
                }
              : i
          ),
        }));
        setEditingCommCaseItemId(null);
        setCommCaseEditDraft({ subject: "", body_text: "" });
      } else {
        toast.error(t("failed.to.update.communication"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("failed.to.update.communication"));
    } finally {
      setSavingCommCaseEdit(false);
    }
  };

  const handleUpdateCaseItem = async (itemId, payload) => {
    if (!caseItem?.id) return;
    try {
      const response = await updateCaseItem(caseItem.id, itemId, payload);
      const item = response?.data || response;
      if (item?.id) {
        toast.success(t("Update saved"));
        setCaseItemsState((prev) => ({
          ...prev,
          data: prev.data.map((i) => (i.id === itemId ? item : i)),
        }));
        setEditingItemId(null);
      } else {
        const errMsg = item?.errors?.[0] || t("Could not save");
        toast.error(errMsg);
      }
    } catch (err) {
      toast.error(t("Could not save"));
    }
  };

  const handleAddCaseItem = async (payload) => {
    if (!caseItem?.id) return;
    try {
      const response = await createCaseItem(payload);
      const item = response?.data || response;
      if (item?.id) {
        toast.success(t("Update added"));
        setCaseItemsState((prev) => ({
          ...prev,
          data: sortCaseItemsAsc([...(prev.data || []), item]),
          totalCount: prev.totalCount + 1,
        }));
        setItemDocumentRefreshMap((prev) => ({
          ...prev,
          case: (prev.case || 0) + 1,
        }));
        requestAnimationFrame(() => {
          scrollItemsToComposer();
        });
      } else {
        const errMsg = item?.errors?.[0] || item?.data?.errors?.[0] || t("Could not add update");
        toast.error(errMsg);
        throw new Error(errMsg);
      }
    } catch (err) {
      toast.error(t("Could not add update"));
      throw err;
    }
  };

  // if (itemTags && caseItem?.id === null) {
  //   useEffect(() => {
  //     const tags = itemTags.map((item) => {
  //       return {
  //         module: item.module,
  //         module_param: item.module_param,
  //         object: item.object,
  //       };
  //     });

  //     // add to first item in items
  //     setItemState((prevState) => ({
  //       ...prevState,
  //       caseItem: {
  //         ...prevState.caseItem,
  //         items: [{ description: "", tags: tags }],
  //       },
  //     }));
  //   }, [itemTags]);
  // }

  function caseInputs(formik) {
    return (
      <>
        <div className="flex gap-2">
          <CaseStatus caseItem={caseItem} />
          <CasePriorityStatus priority={caseItem?.priority} />
        </div>

        {/* <div className="grid grid-cols-2 gap-3">
          <div>
            <p className="text-xs font-medium text-gray-500">{t("Case Number")}</p>
            <p className="text-sm text-gray-900">
              {typeof caseItem?.case_number === "string" || typeof caseItem?.case_number === "number"
                ? String(caseItem.case_number)
                : "–"}
            </p>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-500">{t("Case Date")}</p>
            <p className="text-sm text-gray-900">
              {caseItem?.date && typeof caseItem.date !== "object"
                ? dateToString(caseItem.date)
                : caseItem?.date?.date
                  ? dateToString(caseItem.date.date)
                  : "–"}
            </p>
          </div>
        </div> */}

        <div>
          <PMField name="title" type="text" label={t("Tittel")} {...formik} />
        </div>

        {!props.customer?.id && (
          <div>
            <CustomerSelector
              selected={
                caseItem?.customer?.id
                  ? { id: caseItem.customer.id, displayTitle: safeString(caseItem.customer?.displayTitle ?? caseItem.customer?.name), name: safeString(caseItem.customer?.name) }
                  : customer?.id
                    ? { id: customer.id, displayTitle: safeString(customer?.displayTitle ?? customer?.name), name: safeString(customer?.name) }
                    : null
              }
              searchQuery={typeof caseItemFields?.name === "string" ? caseItemFields.name : ""}
              {...formik}
              fields={caseItemFields}
            />
          </div>
        )}

        <div>
          <ContactsSelector
            selected={
              caseItem?.contact?.id
                ? { id: caseItem.contact.id, displayTitle: safeString(caseItem.contact?.displayTitle ?? caseItem.contact?.name), name: safeString(caseItem.contact?.name) }
                : contact?.id
                  ? { id: contact.id, displayTitle: safeString(contact?.displayTitle ?? contact?.name), name: safeString(contact?.name) }
                  : null
            }
            searchQuery={typeof caseItemFields?.name === "string" ? caseItemFields.name : ""}
            fields={caseItemFields}
            {...formik}
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              {t("Case Type")}
            </label>
            {(() => {
              const selectedType = caseTypeOptions.data?.find(
                (opt) => String(opt.value) === String(formik.values.case_type_id)
              );
              return (
                <button
                  type="button"
                  onClick={() => setShowCaseTypeDialog(true)}
                  className={`w-full rounded-2xl border px-4 py-3 text-left text-sm transition-colors ${
                    selectedType
                      ? "border-blue-200 bg-blue-50 text-blue-800 ring-1 ring-blue-100"
                      : "border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300 hover:bg-slate-100"
                  }`}
                >
                  <span className="font-medium">
                    {selectedType?.title
                      ? t(String(selectedType.title))
                      : t("Select case type")}
                  </span>
                </button>
              );
            })()}
            {formik.errors.case_type_id && formik.touched.case_type_id && (
              <p className="mt-1 text-sm text-red-600">{formik.errors.case_type_id}</p>
            )}
            {caseItem?.id && formik.values.case_type_id && (
              <button
                type="button"
                onClick={() => openCaseGuide(formik.values.case_type_id, "request_info")}
                className="mt-2 inline-flex items-center gap-2 rounded-md bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-700 ring-1 ring-emerald-200 hover:bg-emerald-100"
              >
                <QuestionMarkCircleIcon className="h-4 w-4" />
                {t("Etterspørre info")}
              </button>
            )}
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              {t("Priority")}
            </label>
            {(() => {
              const priority = priorityOptions.find(
                (opt) => String(opt.value) === String(formik.values.priority)
              );
              return (
                <button
                  type="button"
                  onClick={() => setShowPriorityDialog(true)}
                  className={`w-full rounded-2xl border px-4 py-3 text-left text-sm font-medium transition-colors ${
                    priority
                      ? `${priority.class} border-slate-200 ring-1 ring-slate-100`
                      : "border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300 hover:bg-slate-100"
                  }`}
                >
                  {priority?.label ? t(String(priority.label)) : t("Select Priority")}
                </button>
              );
            })()}
            {formik.errors.priority && formik.touched.priority && (
              <p className="mt-1 text-sm text-red-600">{formik.errors.priority}</p>
            )}
          </div>
        </div>

        <CaseUserAssignedField
          userId={formik.values.user_assigned_id}
          caseUserAssigned={caseItem?.user_assigned}
          userOptions={userOptions.data}
          formik={formik}
        />

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">{t("Labels")}</label>
          <CaseTagSelector name="tag_ids" formik={formik} showBadges={true} />
        </div>

        <div>
          <PMDatePicker
            name="due_date"
            label={t("Forfallsdato")}
            value={
              typeof formik.values.due_date === "string" ? formik.values.due_date : ""
            }
            onChange={(e) => {
              formik.setFieldValue("due_date", e.target.value || null);
            }}
            errors={formik.errors.due_date}
            touched={formik.touched.due_date}
          />
        </div>

        {!caseItem?.id && (
          <div>
            <label htmlFor="description" className="block text-xs font-medium text-gray-700 mb-1">
              {t("Description")}
            </label>
            <textarea
              wrap="off"
              rows={4}
              name="description"
              id="description"
              className="block w-full rounded-md border-gray-300 text-gray-900 text-sm placeholder:text-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              placeholder={t("Write a description...")}
              value={typeof formik.values?.items?.[0]?.description === "string" ? formik.values.items[0].description : ""}
              onChange={(e) => handleDescriptionItemChange(e, formik)}
            />
          </div>
        )}
      </>
    );
  }
  const timeToClockString = (dateTime) => {
    if (dateTime == null) return "";
    const str = typeof dateTime === "string" ? dateTime : String(dateTime);
    return new Date(str).toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit", hour12: false });
  };

  const getDateGroupLabel = (dateTime) => {
    if (dateTime == null) return "";
    const d = new Date(dateTime);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (d.toDateString() === today.toDateString()) return t("I dag");
    if (d.toDateString() === yesterday.toDateString()) return t("I går");
    return d.toLocaleDateString("nb-NO", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  };

  const isItemEdited = (item) => {
    if (!item?.created_at || !item?.updated_at) return false;
    const created = new Date(item.created_at).getTime();
    const updated = new Date(item.updated_at).getTime();
    return updated - created > 2000;
  };

  function caseItems() {
    if (caseItemsState.isLoading) {
      return (
        <div className="px-3 py-4">
          <ResourceLoading />
        </div>
      );
    }

    const itemsByDate = (caseItemsState?.data || []).reduce((acc, item) => {
      const key = item?.created_at ? new Date(item.created_at).toDateString() : "unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    const sortedDateKeys = Object.keys(itemsByDate).sort((a, b) => new Date(a) - new Date(b));

    return (
      <div className="pt-0 pb-24 md:pt-10 flex-1 flex flex-col min-w-0 min-h-0">
        <div className="flex justify-center px-3">
          <ul role="list" className="divide-y divide-gray-100 w-full max-w-2xl">
            {caseItemsState.isLoadingMore && (
              <li className="py-2 text-xs text-gray-500">{t("Laster eldre oppdateringer...")}</li>
            )}
            {sortedDateKeys.map((dateKey) => (
              <Fragment key={dateKey}>
                <li className="py-2">
                  <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                    {getDateGroupLabel(itemsByDate[dateKey][0]?.created_at)}
                  </div>
                </li>
                {itemsByDate[dateKey].map((item) => {
                  const edited = isItemEdited(item);
                  const isOwnItem = item?.user?.id != null && currentUser?.id != null && Number(item.user.id) === Number(currentUser.id);
                  return (
                <li key={item.id} className="py-2">
                  <div className={TWclassNames(
                    "flex items-stretch",
                    isOwnItem ? "justify-end" : "justify-start"
                  )}>
                  <div className={TWclassNames(
                    "min-w-0 max-w-[85%] rounded-lg border px-4 py-3 shadow-sm",
                    isOwnItem ? "bg-emerald-50 border-emerald-200" : "bg-gray-50 border-gray-200"
                  )}>
                  <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-1.5 text-xs text-gray-600 min-w-0">
                      <span>
                        <span className="font-medium text-blue-600">{safeString(item?.user?.name, "Systemet")}</span>
                        {" · "}
                        {itemActivityLabel(item)}
                        {" · "}
                        <time dateTime={item?.created_at}>{timeToClockString(item?.created_at)}</time>
                        {item?.priority != null && item.priority !== "" && (
                          <span className="ml-1.5">
                            <CasePriorityStatus priority={item.priority} />
                          </span>
                        )}
                        {edited && <span className="ml-1 italic text-gray-400">({t("Redigert")})</span>}
                      </span>
                    </div>

                    <div className="flex items-center gap-0.5 flex-shrink-0">
                        {isItemExpandable(item) && (
                          <button
                            type="button"
                            onClick={() => toggleItemExpansion(item.id)}
                            className="text-gray-400 hover:text-gray-600 p-0.5 rounded"
                            title={isItemExpanded(item.id) ? "Collapse" : "Expand"}
                          >
                            <ChevronDownIcon
                              className={`h-4 w-4 transition-transform ${
                                isItemExpanded(item.id) ? "rotate-180" : ""
                              }`}
                            />
                          </button>
                        )}
                        {canModifyItem(item) && (item?.module === "description" || (item?.module === "case" && item?.action === "UPDATE")) && (
                          <button
                            type="button"
                            onClick={() => {
                              setEditingCommCaseItemId(null);
                              setCommCaseEditDraft({ subject: "", body_text: "" });
                              setEditingItemId(item.id);
                              setEditingItemDraft({
                                title: typeof item.title === "string" ? item.title : "",
                                description: typeof item.description === "string" ? item.description : "",
                              });
                            }}
                            className="text-gray-400 hover:text-blue-600 p-0.5 rounded"
                            title={t("Edit")}
                          >
                            <PencilSquareIcon className="h-4 w-4" />
                          </button>
                        )}
                        {item?.module === "customer_communication" &&
                          canEditOwnCustomerHandlerCommunication(item.module_object) && (
                          <button
                            type="button"
                            onClick={() => {
                              setEditingItemId(null);
                              setEditingItemDraft({ title: "", description: "" });
                              const comm = item.module_object;
                              setEditingCommCaseItemId(item.id);
                              setCommCaseEditDraft({
                                subject: typeof comm?.subject === "string" ? comm.subject : "",
                                body_text: typeof comm?.body_text === "string" ? comm.body_text : "",
                              });
                            }}
                            className="text-gray-400 hover:text-blue-600 p-0.5 rounded"
                            title={t("customer.handler.edit.communication")}
                          >
                            <PencilSquareIcon className="h-4 w-4" />
                          </button>
                        )}
                        {canModifyItem(item) && (
                          <button
                            type="button"
                            onClick={() => handleDeleteItem(item.id)}
                            className="text-gray-400 hover:text-red-500 p-0.5 rounded"
                            title={t("Delete")}
                          >
                            <TrashIcon className="h-4 w-4" />
                          </button>
                        )}
                      </div>
                    </div>

                    {/* System/audit cards: EMAIL_SENT_TO_EMPLOYEE, CHANGED */}
                    {item?.action === "EMAIL_SENT_TO_EMPLOYEE" && (
                      <div className="rounded-md p-4 bg-blue-50 border border-blue-200">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <EnvelopeOpenIcon className="h-5 w-5 text-blue-500" />
                          </div>
                          <div className="ml-3">
                            <h3 className="text-sm font-medium text-blue-800">
                              {t("Sendt e-post til ansatt")}
                            </h3>
                            <p className="mt-1 text-sm text-blue-700">
                              {(() => {
                                const label = item?.module_object?.displayTitle || item?.module_object?.name;
                                const userId = item?.module_object?.id ?? item?.module_param;
                                if (label && userId) {
                                  return (
                                    <Link to={`/dashboard/users/${userId}`} className="text-blue-600 hover:underline">
                                      {label}
                                    </Link>
                                  );
                                }
                                if (label) return label;
                                if (userId) return <Link to={`/dashboard/users/${userId}`} className="text-blue-600 hover:underline">{t("Ansatt")} #{userId}</Link>;
                                return t("Ansatt");
                              })()}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {item?.action === "CHANGED" && item?.item_change && (
                      <div className="rounded-md p-4 bg-amber-50 border border-amber-200">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <PencilSquareIcon className="h-5 w-5 text-amber-500" />
                          </div>
                          <div className="ml-3 flex-1">
                            <h3 className="text-sm font-medium text-amber-800">{ACTION(item?.action)}</h3>
                            <div className="mt-2 text-sm text-amber-700">
                              <ChangedValues module={item?.action} change={item?.item_change} />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {item?.item_change && item?.action !== "CHANGED" && (
                      <div className="py-1.5">
                        <ChangedValues
                          module={item?.action}
                          change={item?.item_change}
                        />
                      </div>
                    )}

                    {/* Inline edit for own items (description or case/UPDATE posts) */}
                    {editingItemId === item.id && (item?.module === "description" || (item?.module === "case" && item?.action === "UPDATE")) && (
                      <div className="mt-2 p-2.5 rounded-lg border border-blue-200 bg-blue-50/50">
                        <input
                          type="text"
                          value={typeof editingItemDraft.title === "string" ? editingItemDraft.title : ""}
                          onChange={(e) => setEditingItemDraft((p) => ({ ...p, title: e.target.value }))}
                          placeholder={t("Title (optional)")}
                          className="mb-2 w-full rounded border border-gray-200 px-2 py-1.5 text-sm"
                        />
                        <MentionTextEditor
                          value={typeof editingItemDraft.description === "string" ? editingItemDraft.description : ""}
                          onChange={(v) => setEditingItemDraft((p) => ({ ...p, description: v }))}
                          minHeight={80}
                          maxHeight={150}
                        />
                        <div className="mt-2 flex gap-2">
                          <button
                            type="button"
                            onClick={() => handleUpdateCaseItem(item.id, {
                              title: editingItemDraft.title,
                              description: editingItemDraft.description || " ",
                            })}
                            className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700"
                          >
                            {t("Save")}
                          </button>
                          <button
                            type="button"
                            onClick={() => { setEditingItemId(null); setEditingItemDraft({ title: "", description: "" }); }}
                            className="rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                          >
                            {t("Cancel")}
                          </button>
                        </div>
                      </div>
                    )}

                    {editingCommCaseItemId === item.id && item?.module === "customer_communication" && item?.module_object?.id && (
                      <div className="mt-2 p-2.5 rounded-lg border border-blue-200 bg-blue-50/50">
                        <input
                          type="text"
                          value={commCaseEditDraft.subject}
                          onChange={(e) => setCommCaseEditDraft((p) => ({ ...p, subject: e.target.value }))}
                          placeholder={t("customer.handler.communication.subject")}
                          className="mb-2 w-full rounded border border-gray-200 px-2 py-1.5 text-sm"
                        />
                        <textarea
                          rows={5}
                          value={commCaseEditDraft.body_text}
                          onChange={(e) => setCommCaseEditDraft((p) => ({ ...p, body_text: e.target.value }))}
                          placeholder={t("customer.handler.communication.body")}
                          className="w-full rounded border border-gray-200 px-2 py-1.5 text-sm"
                        />
                        <div className="mt-2 flex gap-2">
                          <button
                            type="button"
                            disabled={savingCommCaseEdit}
                            onClick={() => handleSaveCustomerCommunicationCaseItem(item)}
                            className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700 disabled:opacity-50"
                          >
                            {t("Save")}
                          </button>
                          <button
                            type="button"
                            disabled={savingCommCaseEdit}
                            onClick={() => {
                              setEditingCommCaseItemId(null);
                              setCommCaseEditDraft({ subject: "", body_text: "" });
                            }}
                            className="rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                          >
                            {t("Cancel")}
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Expandable content section for items with description or module content */}
                    {isItemExpandable(item) && editingItemId !== item.id && editingCommCaseItemId !== item.id && (
                      <div
                        className={`transition-all duration-200 overflow-hidden ${
                          isItemExpanded(item.id)
                            ? "max-h-screen opacity-100"
                            : "max-h-0 opacity-0"
                        }`}
                      >
                        <div className="pt-2 border-t border-gray-100 text-sm">
                          <div className="">
                            {/* Only show title for description module items */}
                            {item?.module === "description" && typeof item?.title === "string" && item.title.trim() && (
                              <p className="font-semibold text-gray-900 mb-2">{item.title}</p>
                            )}
                            {/* Only show module content if it exists */}
                            {displayModuleContent(item)}

                            {/* Only show description if it exists (HTML for mentions, else plain) */}
                            {item?.description &&
                              typeof item.description === "string" &&
                              item.description.trim() !== "" && (
                                <CaseItemDescription value={item.description} />
                              )}

                            {/* Only show tags if they exist */}
                            {item?.tags && item.tags.length > 0 && (
                              <div className="mt-2">
                                <TagsView tags={item?.tags} />
                              </div>
                            )}
                          </div>
                          {item?.documents?.length > 0 && (
                            <div className="mt-4">
                              <TinyDocumentSection
                                showNoDocuments={false}
                                pathType="url"
                                module="CASE_ITEM"
                                moduleParam={item?.id}
                                refreshTrigger={itemDocumentRefreshMap[item?.id] || 0}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Always visible content for non-expandable items (ADDED/UPDATE case items) */}
                    {!isItemExpandable(item) && editingItemId !== item.id && editingCommCaseItemId !== item.id && (
                      <div className="">
                        {/* Only show title for description module items */}
                        {item?.module === "description" && typeof item?.title === "string" && item.title.trim() && (
                          <p className="font-semibold text-gray-900 mb-2">{item.title}</p>
                        )}
                        {displayModuleContent(item)}

                        {/* Don't show raw descriptions for modules that render their own structured card */}
                        {item?.module !== "customer_communication" && item?.module !== "case_guide_run" && typeof item?.description === "string" && (
                          <CaseItemDescription value={item.description} />
                        )}

                        <div className="mt-2">
                          <TagsView tags={item?.tags} />
                        </div>
                      </div>
                    )}

                    {/* Always visible documents for non-expandable items */}
                    {!isItemExpandable(item) && item?.documents?.length > 0 && (
                      <div className="mt-2">
                        <TinyDocumentSection
                          showNoDocuments={false}
                          pathType="url"
                          module="CASE_ITEM"
                          moduleParam={item?.id}
                          refreshTrigger={itemDocumentRefreshMap[item?.id] || 0}
                        />
                      </div>
                    )}
                  </div>
                  </div>
                </li>
                );
              })}
            </Fragment>
          ))}
          {!caseItemsState?.data?.length && (
            <li className="list-none py-0">
              <div className="flex flex-col items-center justify-center py-16 px-6 rounded-lg border-2 border-dashed border-gray-200 bg-gray-50/50 mt-6">
                <p className="text-base text-gray-500 text-center font-medium">{t("case.empty.updates")}</p>
                <p className="text-sm text-gray-400 text-center mt-1">{t("case.empty.hint")}</p>
              </div>
            </li>
          )}
          </ul>
        </div>
      </div>
    );
  }

  const IsEditingListner = () => {
    // const { values } = useFormikContext();
    // useEffect(() => {
    //   onEditing(true);
    // }, [values]);
  };

  const [finishCase, setFinishCase] = useState(false);
  const [finishQuestionPromptOpen, setFinishQuestionPromptOpen] =
    useState(false);
  const [moduleType, setModuleType] = useState(null);

  const onUpdateModuleChange = (type, data) => {
    // ids objects depending on type
    const id_name = {
      report: "report_id",
      project: "project_id",
      service_agreement: "service_agreement_id",
    };

    const payload = {
      id: caseItem.id,
      [id_name[type]]: data?.id,
    };

    // add status: 'FINISH' if report is finished
    if (finishCase) {
      payload.status = "FINISHED";
    }

    dispatch(updateCaseAsync(payload));

    setFinishCase(false);
  };

  const promptBeforeModuleDialog = (type) => {
    setModuleType(type);
    if (!caseItem?.[type]?.id) {
      setFinishQuestionPromptOpen(true);
    } else {
      openModuleDialog(type);
    }
  };

  const handleFinishQuestion = (boolean) => {
    if (boolean) {
      setFinishCase(boolean);
    }
    setFinishQuestionPromptOpen(false);
    openModuleDialog(moduleType);
  };

  const openModuleDialog = (type) => {
    // Open module dialog depending on type
    switch (type) {
      case "report":
        setReportDialogOpen(true);
        break;
      case "service_agreement":
        setServiceAgreementDialogOpen(true);
        break;
      default:
        toast.error("Missing dialog for this module");
        break;
    }
  };

  // Format caseItem fields to find object by name
  const caseItemFields = caseItem?.fields?.reduce((acc, field) => {
    acc[field.name] = field.value;
    return acc;
  }, {});

  function handleNewCaseItems(data) {
    setCaseItemsState((prev) => ({
      ...prev,
      data: sortCaseItemsAsc([...(prev.data || []), data]),
      totalCount: prev.totalCount + 1,
    }));

    // Only trigger document refresh for the specific new item
    setItemDocumentRefreshMap(prev => ({
      ...prev,
      [data.id]: (prev[data.id] || 0) + 1
    }));
  }

  const [closeCasepromptOpen, setCloseCasepromptOpen] = useState(false);
  const [finishCasepromptOpen, setFinishCasepromptOpen] = useState(false);
  const [removeCasePromptOpen, setRemoveCasePromptOpen] = useState(false);
  const [itemDocumentRefreshMap, setItemDocumentRefreshMap] = useState({});

  const updateAndCloseCase = async (formik) => {
    await formik.setFieldValue("status", "CLOSED");
    await formik.submitForm();
    navigate("/dashboard/cases");
  };

  const updateAndFinishCase = async (formik) => {
    await formik.setFieldValue("status", "FINISHED");
    await formik.submitForm();
    navigate("/dashboard/cases");
  };

  const removeCase = async (id) => {
    dispatchWithToast(
      dispatch(deleteCaseAsync({ id: id }), null, navigate("/dashboard/cases"))
    );
  };

  const dropdownActions = [
    {
      label: "edit",
      children: [
        {
          label: t("Save and finish"),
          icon: PencilSquareIcon,
          action: () => setFinishCasepromptOpen(true),
        },
        {
          label: t("Save and close"),
          icon: PencilSquareIcon,
          action: () => setCloseCasepromptOpen(true),
        },
        {
          label: t("Etterspørre info"),
          icon: QuestionMarkCircleIcon,
          action: () => openCaseGuide(caseItem?.case_type?.id, "request_info"),
        },
        {
          label: t("Delete"),
          icon: TrashIcon,
          action: () => setRemoveCasePromptOpen(true),
        },
      ],
    },
  ];

  const fieldOrCustomerAddressObject = (item) => {
    if (
      item?.customer?.postal_address &&
      item?.customer?.postal_address?.address !== "null"
    ) {
      return item?.customer?.postal_address;
    }

    const address = searchFieldsByName(item, "address")?.value;

    if (address) {
      const address2 = searchFieldsByName(item, "address2")?.value;
      const postal = searchFieldsByName(item, "postal")?.value;
      const place = searchFieldsByName(item, "place")?.value;

      // find fields

      return {
        address: address,
        address2: address2,
        postal: postal,
        place: place,
      };
    }

    return null;
  };

  return (
    <DashboardHeader
      compact
      subtitle={safeString(caseItem?.customer?.displayTitle)}
      actions={[]}
      title={
        (safeString(caseItem?.title) || "Mangler tittel") +
        " - SAK-" +
        safeString(caseItem?.case_number)
      }
      meta={[]}
      mainButton={{
        label: "New",
        action: () => setCreateCaseDialogOpen(true),
        path: null,
        color: "",
        icon: PlusIcon,
      }}
    >
      {isLoading ? (
        <ResourceLoading />
      ) : (
        <div className="mx-auto px-0 md:px-2 flex-1 min-h-0 flex flex-col md:pr-80 lg:pr-96 overflow-hidden w-full">
          <div className="flex-1 min-h-0 flex flex-col rounded-none sm:rounded-lg overflow-hidden pt-0 sm:pt-2 pb-44">
            <Formik
              enableReinitialize
              initialValues={{
                id: caseItem?.id,
                customer_id: caseItem?.customer
                  ? caseItem?.customer?.id
                  : customer?.id
                  ? customer?.id
                  : null,
                contact_id: caseItem?.contact
                  ? caseItem?.contact?.id
                  : contact?.id
                  ? contact?.id
                  : null,
                report_id: caseItem?.report
                  ? caseItem?.report?.id
                  : report?.id
                  ? report?.id
                  : null,
                project_id: caseItem?.project
                  ? caseItem?.project?.id
                  : project?.id
                  ? project?.id
                  : null,
                case_number: caseItem?.case_number,
                date: caseItem?.date
                  ? caseItem?.date
                  : new Date().toISOString().substring(0, 10),
                title: safeString(caseItem?.title) || safeString(title) || "",
                description: caseItem?.description,
                case_type_id: caseItem?.case_type?.id,
                module: props?.module,
                module_param: props?.module_param,
                user_responsible_id: caseItem?.user_responsible?.id,
                user_assigned_id:
                  caseItem?.user_assigned?.id || currentUser?.id,
                note: caseItem?.note,
                priority: caseItem?.priority?.toString() || "1",
                due_date: (() => {
                  const d = caseItem?.due_date;
                  if (typeof d === "string") return d;
                  if (d?.date) return d.date;
                  return new Date().toISOString().substring(0, 10);
                })(),
                tag_ids: caseItem?.tag_definitions?.map((t) => t.id) ?? [],

                items: [
                  {
                    description: null,
                  },
                ],

                submit: null,
              }}
              validationSchema={Yup.object({
                case_type_id: Yup.string().required("A case type is required"),
              })}
              onSubmit={async (values, helpers) => {
                if (!caseItem?.id) {
                  try {
                    const result = await createOrUpdateDispatch(values);
                    const payload = result?.payload ?? result;
                    const createErrors = payload?.errors ?? payload?.data?.errors;
                    if (createErrors) {
                      helpers.setErrors({ submit: Array.isArray(createErrors) ? createErrors.join(", ") : String(createErrors) });
                      helpers.setSubmitting(false);
                      return;
                    }
                    const createdCase = normalizeCaseItem(payload?.data ?? payload);
                    const pendingGuideRun = caseGuideState.pendingRun;
                    if (createdCase?.id && pendingGuideRun) {
                      const guideResponse = await createCaseGuideRun(
                        createdCase.id,
                        {
                          case_guide_template_id: pendingGuideRun.case_guide_template_id,
                          purpose: pendingGuideRun.purpose,
                          answers: pendingGuideRun.answers,
                          requested_from_customer: false,
                        },
                        { fields: CASE_DETAIL_FIELDS_WITHOUT_ITEMS }
                      );
                      if (guideResponse?.errors) {
                        toast.error(Array.isArray(guideResponse.errors) ? guideResponse.errors.join(", ") : String(guideResponse.errors));
                        setCaseGuideState((prev) => ({ ...prev, pendingRun: null }));
                      } else {
                        if (guideResponse?.case) {
                          Object.assign(createdCase, normalizeCaseItem(guideResponse.case));
                        }
                        const chained = await chainNextGuideIfNeeded(createdCase.id, guideResponse, pendingGuideRun.purpose);
                        if (!chained) {
                          setCaseGuideState((prev) => ({ ...prev, pendingRun: null }));
                        }
                      }
                    }
                    setItemState((prevState) => ({
                      ...prevState,
                      caseItem: createdCase,
                    }));
                    if (!id && createdCase?.id) {
                      navigate(`/dashboard/cases/${createdCase.id}`, { replace: true });
                    }
                    helpers.setStatus({ success: true });
                  } catch (err) {
                    console.error(err);
                    helpers.setStatus({ success: false });
                    helpers.setErrors({ submit: err.message });
                  }
                  helpers.setSubmitting(false);
                  return;
                }
                setSaveState((s) => ({ ...s, isSaving: true, isError: false, isSuccess: false, errorMessage: null }));
                try {
                  const result = await createOrUpdateDispatch(values);
                  const payload = result?.payload ?? result;
                  const errs = payload?.errors ?? payload?.data?.errors;
                  if (errs) {
                    setSaveState({
                      isSaving: false,
                      isError: true,
                      errorMessage: Array.isArray(errs) ? errs.join(", ") : String(errs),
                    });
                    return;
                  }
                  if (payload?.id) {
                    setItemState((prevState) => ({
                      ...prevState,
                      caseItem: normalizeCaseItem(payload) ?? payload,
                    }));
                    setSaveState({ isSaving: false, isSuccess: true });
                    helpers.resetForm({ values });
                  } else {
                    setSaveState({ isSaving: false, isError: true, errorMessage: t("Could not save") });
                  }
                } catch (err) {
                  console.error(err);
                  setSaveState({
                    isSaving: false,
                    isError: true,
                    errorMessage: err?.message || t("Could not save"),
                  });
                }
                helpers.setSubmitting(false);
              }}
            >
              {(formik) => {
                formikRef.current = formik;
                return (
                <>
                <PostCreateGuidePrompt />
                {caseItem?.id && (
                  <CaseFormFocusListeners
                    sidebarRef={caseFormSidebarRef}
                    panelRef={caseFormPanelRef}
                    formikRef={formikRef}
                    caseId={caseItem.id}
                  />
                )}
                <div className="flex flex-1 min-h-0 min-w-0 flex-col overflow-hidden">
                <Form className={caseItem?.id ? "flex flex-1 min-h-0 min-w-0 flex-row overflow-hidden" : "flex flex-1 flex-col min-h-0 min-w-0"}>
                  {/* Items + Update composer (Notion-style) - centered, wider - only when case exists */}
                  {caseItem?.id && (
                    <div className="flex-1 flex min-h-0 min-w-0 overflow-hidden w-full md:justify-center pl-0 pr-0 md:pl-[50px] md:pr-6 md:pr-24">
                      {/* Phone: always full width. PC: fixed width (doesn't shrink with content). */}
                      <div className="flex flex-col flex-1 min-h-[50vh] mt-0 mb-12 md:mt-10 md:mb-20 w-full min-w-0 max-w-full border-x-0 md:border-x md:border-gray-200 bg-white md:min-w-[min(1280px,calc(100vw-3.125rem-16rem-24rem))] md:w-[min(1280px,calc(100vw-3.125rem-16rem-24rem))] md:shrink-0">
                      <div
                        ref={caseContentScrollRef}
                        onScroll={handleCaseItemsScroll}
                        className="flex-1 min-h-0 overflow-y-auto"
                      >
                        {caseItems()}
                      </div>
                    </div>
                    </div>
                  )}
                  {/* Composer: fixed to viewport bottom - only composer area has background */}
                  {caseItem?.id && (
                    <div ref={composerRef} className="fixed bottom-0 left-0 right-0 md:right-80 lg:right-96 z-30 p-3 pointer-events-none">
                      <div className="mx-auto max-w-2xl pointer-events-auto bg-white rounded-t-lg border border-b-0 border-gray-200 shadow-[0_-4px_15px_rgba(0,0,0,0.08)] p-3">
                        <CaseUpdateComposer
                          caseId={caseItem.id}
                          onSubmit={handleAddCaseItem}
                          compact
                          customer={caseItem?.customer}
                        />
                      </div>
                    </div>
                  )}

                  {/* Case menu: on mobile = button + slideover, on desktop = always-visible sidebar */}
                  {/* Mobile: button to open case menu */}
                  {caseItem?.id && (
                    <button
                      type="button"
                      onClick={() => setCaseMenuOpen(true)}
                      className="md:hidden fixed right-4 top-24 z-20 flex items-center justify-center w-10 h-10 rounded-full bg-emerald-600 text-white shadow-lg hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-colors"
                      aria-label={t("Åpne saksmeny")}
                    >
                      <Bars3Icon className="h-5 w-5" />
                    </button>
                  )}
                  {/* Desktop: sidebar fixed to viewport right - sticky to whole Promang frontend */}
                  {caseItem?.id && (
                    <div className="hidden md:flex fixed top-20 right-0 bottom-0 w-80 lg:w-96 z-20 flex-col bg-white border-l border-gray-200 overflow-hidden shadow-[0_0_20px_rgba(0,0,0,0.08)]">
                      <div className="bg-emerald-700 py-4 px-4 sm:px-6 flex-shrink-0">
                        <p className="text-lg font-medium text-white">{t("Saksdetaljer")}</p>
                        <p className="mt-1 text-sm text-emerald-200">
                          {safeString(caseItem?.title)} · SAK-{safeString(caseItem?.case_number)}
                        </p>
                      </div>
                      <div
                      ref={caseFormSidebarRef}
                      className="flex-1 overflow-y-auto p-4 space-y-4 min-h-0"
                    >
                        <div className="flex items-center justify-between">
                          {formik.values.id && (
                            <PMDropdown label={t("Actions")} options={dropdownActions} />
                          )}
                        </div>
                        <div className="w-full">{caseTabs()}</div>
                        {currentTab === 0 && (
                          <div className="space-y-4">
                            <ObjectRenderErrorBoundary>{caseInputs(formik)}</ObjectRenderErrorBoundary>
                            <div className="pt-2 border-t border-gray-200">
                              <PMDropdown
                                label={t("Legg til")}
                                options={[{ label: t("Legg til"), children: rightSideActions.filter((a) => a.show !== false).map((a) => ({ label: a.label, action: a.action, icon: a.icon })) }]}
                              />
                            </div>
                            <div>
                              <GoogleMapsButton address={fieldOrCustomerAddressObject(caseItem)} />
                            </div>
                          </div>
                        )}
                        {currentTab === 1 && caseFields()}
                        {currentTab === 2 && (
                          <div className="py-2">
                            <TinyDocumentSection module="CASE" moduleParam={caseItem?.id} title="Case Documents" refreshTrigger={itemDocumentRefreshMap.case || 0} />
                          </div>
                        )}
                      </div>
                      <div className="flex-shrink-0 border-t border-gray-200 p-4">
                        <button
                          type="button"
                          className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                          onClick={onClose}
                        >
                          {t("Close")}
                        </button>
                      </div>
                    </div>
                  )}
                  {/* Mobile: slideover (when caseMenuOpen) - only on small screens */}
                  {caseItem?.id && (
                    <div className="md:hidden">
                      <Transition.Root show={caseMenuOpen} as={Fragment}>
                        <Dialog as="div" className="relative z-50" onClose={() => setCaseMenuOpen(false)}>
                          <div className="fixed inset-0 bg-black/20" />
                          <div className="fixed inset-0 overflow-hidden">
                            <div className="absolute inset-0 overflow-hidden">
                              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                              <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                              >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md h-full min-h-screen">
                                  <div className="flex h-full min-h-screen flex-col bg-white shadow-xl">
                                    <div className="bg-emerald-700 py-4 px-4 sm:px-6">
                                      <div className="flex items-center justify-between">
                                        <Dialog.Title className="text-lg font-medium text-white">
                                          {t("Saksdetaljer")}
                                        </Dialog.Title>
                                        <button
                                          type="button"
                                          onClick={() => setCaseMenuOpen(false)}
                                          className="rounded-md text-emerald-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                        >
                                          <span className="sr-only">{t("Lukk")}</span>
                                          <XMarkIcon className="h-6 w-6" />
                                        </button>
                                      </div>
                                      <p className="mt-1 text-sm text-emerald-200">
                                        {safeString(caseItem?.title)} · SAK-{safeString(caseItem?.case_number)}
                                      </p>
                                    </div>
                                    <div
                                      ref={caseFormPanelRef}
                                      className="flex-1 overflow-y-auto p-4 space-y-4 min-h-0"
                                    >
                                      <div className="flex items-center justify-between">
                                        {formik.values.id && (
                                          <PMDropdown
                                            label={t("Actions")}
                                            options={dropdownActions}
                                          />
                                        )}
                                      </div>
                                      <div className="w-full">{caseTabs()}</div>
                                      {currentTab === 0 && (
                                        <div className="space-y-4">
                                          <ObjectRenderErrorBoundary>{caseInputs(formik)}</ObjectRenderErrorBoundary>
                                          <div className="pt-2 border-t border-gray-200">
                                            <PMDropdown
                                              label={t("Legg til")}
                                              options={[
                                                {
                                                  label: t("Legg til"),
                                                  children: rightSideActions
                                                    .filter((a) => a.show !== false)
                                                    .map((a) => ({
                                                      label: a.label,
                                                      action: a.action,
                                                      icon: a.icon,
                                                    })),
                                                },
                                              ]}
                                            />
                                          </div>
                                          <div>
                                            <GoogleMapsButton
                                              address={fieldOrCustomerAddressObject(caseItem)}
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {currentTab === 1 && caseFields()}
                                      {currentTab === 2 && (
                                        <div className="py-2">
                                          <TinyDocumentSection
                                            module="CASE"
                                            moduleParam={caseItem?.id}
                                            title="Case Documents"
                                            refreshTrigger={itemDocumentRefreshMap.case || 0}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    <div className="flex-shrink-0 border-t border-gray-200 p-4">
                                      <button
                                        type="button"
                                        className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                                        onClick={onClose}
                                      >
                                        {t("Close")}
                                      </button>
                                    </div>
                                  </div>
                                </Dialog.Panel>
                              </Transition.Child>
                            </div>
                          </div>
                        </div>
                      </Dialog>
                    </Transition.Root>
                    </div>
                  )}
                  {/* Create mode: full-width inline form */}
                  {!caseItem?.id && (
                    <div className="flex-1 flex flex-col bg-gray-50/50 p-4">
                      <div className="flex items-center justify-between">
                        <button
                          type="button"
                          className="rounded-md border border-transparent bg-emerald-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-emerald-700"
                          onClick={formik.submitForm}
                        >
                          {t("Create")}
                        </button>
                      </div>
                      <div className="mt-4 space-y-4">
                        <ObjectRenderErrorBoundary>{caseInputs(formik)}</ObjectRenderErrorBoundary>
                      </div>
                      <div className="mt-auto pt-4">
                        <button
                          type="button"
                          className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                          onClick={onClose}
                        >
                          {t("Close")}
                        </button>
                      </div>
                    </div>
                  )}
                </Form>
                </div>

                <IsEditingListner />

                  {caseItem?.id && (
                    <SaveBar
                      hasChanges={formik.dirty}
                      isSaving={saveState.isSaving}
                      isSuccess={saveState.isSuccess}
                      isError={saveState.isError}
                      errorMessage={saveState.errorMessage}
                      onSave={() => {
                        if (saveTimeoutRef.current) {
                          clearTimeout(saveTimeoutRef.current);
                          saveTimeoutRef.current = null;
                        }
                        formik.submitForm();
                      }}
                      onDismiss={() => {
                        setSaveState((s) => ({ ...s, isSuccess: false, isError: false, errorMessage: null }));
                      }}
                    />
                  )}

                  <SimplePrompt
                    title="Sikker på at du vill lukke saken?"
                    description="Saken lagres og lukkes, men kan åpnes igjen senere."
                    onAccept={() => updateAndCloseCase(formik)}
                    open={closeCasepromptOpen}
                    onClose={() => setCloseCasepromptOpen(false)}
                  />

                  <SimplePrompt
                    title="Sikker på at du vill endre status til ferdig?"
                    description="Saken lagres og markeres som ferdig"
                    onAccept={() => updateAndFinishCase(formik)}
                    open={finishCasepromptOpen}
                    onClose={() => setFinishCasepromptOpen(false)}
                  />

                  <SimplePrompt
                    title="Sikker på at du vill slette saken?"
                    description="Saken slettes permanent."
                    onAccept={() => removeCase(formik.values.id)}
                    open={removeCasePromptOpen}
                    onClose={() => setRemoveCasePromptOpen(false)}
                  />

                  <SimplePrompt
                    title="Sikker på at du vill slette denne linjen?"
                    description="Saken slettes permanent."
                    onAccept={() => removeCaseItem(selectedItem)}
                    open={removeCaseItemPromptOpen}
                    onClose={() => setRemoveCaseItemPromptOpen(false)}
                  />

                  {showCaseTypeDialog &&
                    createPortal(
                      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                        <div
                          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                          onClick={() => {
                            setCaseTypeSearch("");
                            setShowCaseTypeDialog(false);
                          }}
                          aria-hidden="true"
                        />
                        <div
                          className="relative w-full max-w-lg overflow-hidden rounded-[1.5rem] bg-white shadow-xl"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="border-b border-slate-200 px-5 py-4">
                            <div className="flex items-center justify-between gap-4">
                              <div>
                                <h3 className="text-base font-semibold text-slate-900">
                                  {t("Select case type")}
                                </h3>
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  setCaseTypeSearch("");
                                  setShowCaseTypeDialog(false);
                                }}
                                className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
                              >
                                <XMarkIcon className="h-5 w-5" />
                              </button>
                            </div>
                            <div className="relative mt-4">
                              <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
                              <input
                                type="text"
                                value={caseTypeSearch}
                                onChange={(e) => setCaseTypeSearch(e.target.value)}
                                placeholder={t("search")}
                                className="h-11 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-10 pr-3 text-sm text-slate-700 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                          </div>

                          <div className="max-h-[26rem] overflow-y-auto px-3 py-3">
                            {caseTypeOptions.isLoading ? (
                              <div className="px-3 py-8 text-center text-sm text-slate-500">
                                {t("Loading...")}
                              </div>
                            ) : filteredCaseTypeOptions.length === 0 ? (
                              <div className="px-3 py-8 text-center text-sm text-slate-500">
                                {t("No results")}
                              </div>
                            ) : (
                              filteredCaseTypeOptions.map((opt) => {
                                const isSelected =
                                  String(formikRef.current?.values?.case_type_id) ===
                                  String(opt.value);
                                return (
                                  <button
                                    key={String(opt.value)}
                                    type="button"
                                    onClick={() => {
                                      if (formikRef.current) {
                                        formikRef.current.setFieldValue("case_type_id", opt.value);
                                        formikRef.current.setTouched({
                                          ...formikRef.current.touched,
                                          case_type_id: true,
                                        });
                                      }
                                      setCaseTypeSearch("");
                                      setShowCaseTypeDialog(false);
                                    }}
                                    className={`mb-2 flex w-full items-center justify-between rounded-2xl px-4 py-3 text-left text-sm transition ${
                                      isSelected
                                        ? "bg-blue-50 font-medium text-blue-800 ring-1 ring-blue-200"
                                        : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                                    }`}
                                  >
                                    <span>{opt.title ? t(String(opt.title)) : String(opt.value)}</span>
                                    {isSelected ? (
                                      <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700">
                                        {t("Selected")}
                                      </span>
                                    ) : null}
                                  </button>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>,
                      document.body
                    )}

                  {showPriorityDialog &&
                    createPortal(
                      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                        <div
                          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                          onClick={() => setShowPriorityDialog(false)}
                          aria-hidden="true"
                        />
                        <div
                          className="relative w-full max-w-md overflow-hidden rounded-[1.5rem] bg-white shadow-xl"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="border-b border-slate-200 px-5 py-4">
                            <div className="flex items-center justify-between gap-4">
                              <h3 className="text-base font-semibold text-slate-900">
                                {t("Select Priority")}
                              </h3>
                              <button
                                type="button"
                                onClick={() => setShowPriorityDialog(false)}
                                className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
                              >
                                <XMarkIcon className="h-5 w-5" />
                              </button>
                            </div>
                          </div>
                          <div className="max-h-[24rem] space-y-2 overflow-y-auto px-3 py-3">
                            {priorityOptions.map((opt) => (
                              <button
                                key={opt.value}
                                type="button"
                                onClick={() => {
                                  if (formikRef.current) {
                                    formikRef.current.setFieldValue("priority", opt.value);
                                    formikRef.current.setTouched({
                                      ...formikRef.current.touched,
                                      priority: true,
                                    });
                                  }
                                  setShowPriorityDialog(false);
                                }}
                                className={`w-full rounded-2xl px-4 py-3 text-left text-sm font-medium transition-colors ${
                                  String(formikRef.current?.values?.priority) === String(opt.value)
                                    ? `${opt.class} ring-1 ring-slate-200`
                                    : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                                }`}
                              >
                                {t(String(opt.label))}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>,
                      document.body
                    )}
                </>
              );
              }}
            </Formik>
          </div>
        </div>
      )}

      <ServiceReportEditModal
        module="case"
        module_param=""
        customer={caseItem?.customer}
        project={caseItem?.project}
        fields={caseItemFields}
        open={reportDialogOpen}
        onClose={() => setReportDialogOpen(false)}
        selected={caseItem?.report?.id ? caseItem?.report : null}
        onRefresh={(data) => onUpdateModuleChange("report", data)}
      />

      <CustomerDialog
        open={customerDialogOpen}
        onClose={() => setCustomerDialogOpen(false)}
        readOnly={true}
        // selected={{ report.customer }}
        // Only for testing
        selected={caseItem?.customer}
        onRefresh={() => getCase()}
      />

      <ServiceAgreementModal
        open={serviceAgreementDialogOpen}
        onClose={() => {
          setServiceAgreementDialogOpen(false);
        }}
        customer={caseItem?.customer}
        project={caseItem?.project}
        fields={caseItemFields}
        onRefresh={(data) => {
          onUpdateModuleChange("service_agreement", data);
        }}
        selected={
          caseItem?.service_agreement?.id ? caseItem?.service_agreement : null
        }
      />

      <SimplePrompt
        title="Ønsker du å ferdigstille saken etterpå?"
        description=""
        onAccept={() => handleFinishQuestion(true)}
        open={finishQuestionPromptOpen}
        onClose={() => handleFinishQuestion(false)}
      />

      <FieldDialog
        open={fieldDialogOpen}
        onClose={() => setFieldDialogOpen(false)}
        module="case"
        moduleParam={caseItem?.id}
      />

      <GuideTemplatePickerDialog
        open={guidePickerState.open}
        templates={guidePickerState.templates}
        purpose={guidePickerState.purpose}
        onClose={() => setGuidePickerState((prev) => ({ ...prev, open: false }))}
        onSelect={(template) => {
          setGuidePickerState((prev) => ({ ...prev, open: false }));
          openGuideTemplate(template, guidePickerState.purpose);
        }}
      />

      <CaseGuideOnboardingDialog
        open={caseGuideState.open}
        template={caseGuideState.template}
        purpose={caseGuideState.purpose}
        onClose={() => setCaseGuideState((prev) => ({ ...prev, open: false }))}
        onComplete={handleGuideComplete}
      />

      <CaseCreateOnboardingDialog
        open={createCaseDialogOpen}
        onClose={() => setCreateCaseDialogOpen(false)}
      />
    </DashboardHeader>
  );
}
